import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';
import { AppState } from '../state/AppState';

export function selectContentSort(state: AppState): ReadonlyArray<IOrderClause> {
  return state.order.order;
}

export function selectContentSortIgnoreNextUrlChange(state: AppState): boolean {
  return state.order.ignoreNextUrlChange;
}
